import { Brands } from 'src/utilities/shared-types';
import { BrandDisplayName } from 'src/utilities/brand';

export function getBrandDisplayName(brand: string): string {
  return brand?.toUpperCase() === Brands.SEAMLESS
    ? BrandDisplayName.SEAMLESS
    : BrandDisplayName.GRUBHUB;
}
